import { Component, OnInit, ElementRef } from '@angular/core';
import { BpgAdminServices } from '../../bpg-admin/bpg-admin-services';
import { SelfService } from '../../bpg-self-services/self-services.service.ts';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { LandingPaginationDTO } from "../../bpg-common/services/data.services";
import { ConstantValues } from '../../bpg-common/models/bpg-constants';

import { Router } from '@angular/router';
import { BpgCommonService } from '../../bpg-common/services/bpg-common.service';
import { BpgEventsService } from '../../bpg-events/bpg-events.service';
import { EnvironmentConfiguration } from 'src/app/environment/services/environment.configuration';
import { DatePipe, Location } from '@angular/common';
import { UploadService } from './../d-i/upload.service';
import { ViewChild } from '@angular/core';

@Component({
  selector: 'manage-folder',
  templateUrl: './manage-folder.component.html',
  styleUrls: ['./manage-folder.component.css']
})
export class ManageFolderComponent implements OnInit {
  @ViewChild('myInput', { static: false })
  myInputVariable: ElementRef;
  LandingPaginationDTO: LandingPaginationDTO = new LandingPaginationDTO();
  landingDto: any;
  adminData: any;
  userList: any;
  name: any;
  email: any;
  workId: any;
  user: string = null;
  role: string = null;
  roleName: string = null;
  userFirstName: string = null;
  noDataFound: boolean;
  alertSuccess: boolean;
  alertFailure: boolean;
  deleteSuccess: boolean;
  errorMsg: any;
  msg1: string;
  method: string;
  param: any;
  loginData: any;
  loginUserId: string;
  chapterId: number;
  createdBy: any;
  createdDateTime: any;
  modifiedBy: any;
  modifiedDateTime: any;
  userId: any;
  adminId: any;
  numberOfElements: number;
  currentPage: number = 0;
  currentNumberOfElements: number = 10;
  totalPages: number = 0;
  roleList: any;
  tableShow: any;
  limit: number = 10;
  currentShowingElements: number = 10;
  searchKey: any;
  searchTerm: any;
  siteData: any;
  siteList: any;
  siteListSearch: any;
  selectedBpgsData: any;
  bpgList: any;
  bpgListSearch: any;
  selectedSiteId: any;
  selectedBpgSearch: any;
  selectedBpgId: any;
  selectedSite: any;
  selectedSiteSearch: any;

  siteAndPath: any;
  selectedBpg: any;
  allBpgIds: any;
  allSiteIds: any;
  landingData: any;
  loginUserAdminId: any;
  tableresp: boolean;
  loginDetails: any;
  loginDataDetails: any;
  eventPicture: boolean = true;
  uploadFileName: string = null;
  uploadFileExtension: boolean = false;
  width: number;
  height: number;
  lbl: any;
  uploadedFile: string = null;
  action: string = "";
  fileExtensionError: boolean = false;
  fileSizeExtensionError: boolean = false;
  selectedFile: File = null;
  selectedFileName: string = "Upload < 500MB";
  fileName: string = "";
  fileExtension: any;
  fileSize: number;
  fileList: File[] = [];
  eventList: any;
  eventId: number;
  selectedSiteIdSearch: any = 0;
  selectedBpgIdSearch: any = 0;
  page: number = 0;
  isFileUploded: boolean = false;
  documentsFolderList: any = null;

  chapterList: any;
  chapterIds: any;
  timeOutError: boolean;
  timeoutErrorMessage: string = ConstantValues.timeoutErrorMessage;
  awsUrls: any;
  galleryList: any;
  uploadFlag: any = "gallery";
  errorMsgUploadSave: boolean = false;
  leadAdminId: any;
  userAndRoleIdDTO: any;
  documentName: any;
  allowedExtensions: any = ["xls", "xlsx", "doc", "docx", "txt", "pdf"];
  typeList: any[] = [{ type: 'Select All' }, { type: 'Document' }, { type: 'Image' }, { type: 'Video' }];
  filterType: any;
  folderName: any;
  siteName: any;
  bpgName: any;
  folderId: any = null;
  editAndSave:boolean = false;
  alertUpdateSuccess:boolean = false;
  errorMessage:any;
  firstEdit: boolean = false;
  isbpgAdmin: boolean = false;
  isbpgLeadAdmin = false;
  constructor(private userService: SelfService,
    private adminService: BpgAdminServices,
    private spinner: Ng4LoadingSpinnerService,
    
    private bpgCommonService: BpgCommonService,
    private bpgEventsService: BpgEventsService,
    private router: Router,
    private environment: EnvironmentConfiguration,
    private datePipe: DatePipe, private uploadService: UploadService,
    private location: Location) { }

  ngOnInit() {
    if (this.environment.envName == 'dev' || this.environment.envName == 'qa' || this.environment.envName == 'prod') {
              if (localStorage.getItem('loginData')== null || localStorage.getItem('loginData')== undefined) {

	this.router.navigate(['/log-out']);
      }
    }

    if (localStorage.getItem('logOutFlag') == "true") {
      localStorage.clear();
      sessionStorage.clear();
      this.router.navigate(['/log-out']);
      localStorage.setItem("logOutFlag", "true");

    }


    this.loginDataDetails = JSON.parse(localStorage.getItem('loginData'));

    localStorage.removeItem('searchedEventsCaledarItems');
    this.loginDetails = JSON.parse(localStorage.getItem("loginData"));
    this.adminId = localStorage.getItem('adminId');
    // if (this.adminId != 1 && this.adminId != 2) {
    //   this.router.navigate(['/site-home']);
    // }
    // if (this.loginDetails == null) {
    //   this.router.navigate(['/login']);
    // }
    this.spinner.show();
    sessionStorage.removeItem("MembershipData");
    this.selectedSiteId = localStorage.getItem('userSiteId');
    this.leadAdminId = localStorage.getItem('leadAdminId');
    if (this.leadAdminId === 'true' && !this.isbpgAdmin) {
      localStorage.setItem('adminId', '2');

    }
    this.loginUserAdminId = localStorage.getItem('adminId');

    this.userAndRoleIdDTO = {
      userId: this.loginDataDetails['userId'],
      roleId: localStorage.getItem('adminId')

    }

    this.loginData = JSON.parse(localStorage.getItem('loginData'));
    this.createdBy = this.loginData.userId;
    this.modifiedBy = this.loginData.userId;
    if(localStorage.getItem('isbpgAdmin') == 'true')
    {
      this.isbpgAdmin = true
}
if(localStorage.getItem('isbpgLeadAdmin') === 'true')
    {
      this.isbpgLeadAdmin = true
}
    if (this.loginUserAdminId === "2" || this.loginUserAdminId === "3" || this.isbpgAdmin || this.isbpgLeadAdmin) {
      // this.getSiteforAdmins();
      this.bpgEventsService.getChapterDropDown(this.userAndRoleIdDTO).subscribe(data => {
	this.chapterList = data;
	// this.chapterList.map((i) => { i.siteName = i.siteName + '-' + i.bpgName; return i; })
	if (this.chapterList.length > 1) {
	  this.chapterList.unshift({ chapterId: 0, siteName: 'Select All', bpgName: '' });
	}
	for (let i = 0; i < this.chapterList.length; i++) {
	  if (i == 0) {
	    this.chapterIds = this.chapterList[i].chapterId;
	  }
	  else {
	    this.chapterIds = this.chapterIds + "," + this.chapterList[i].chapterId;
	  }
	}

	this.siteData = {
	  "filter": {
	    chapterId: this.chapterIds
	  },
	  "moduleId": 0,
	  "page": 0,
	  "presentRole": "",
	  "searchTerm": "",
	  "size": 0,
	  "sortDirection": "ASC",
	  "sortProperty": "",
	  "uid": ""
	}
	this.bpgCommonService.getSiteList(this.siteData).subscribe(data => {
	  this.siteList = data;
	  this.siteListSearch = data
	  //filter default site from sitelist
	  this.siteList = this.siteList.filter(site => site.locationCode !== 'DFLT');
	  this.siteListSearch = this.siteListSearch.filter(site => site.locationCode !== 'DFLT');

	  //this.siteList.unshift({ siteId: 0, siteName: 'Select Site', bpgName: '' });
	  this.siteListSearch.unshift({ siteId: 0, siteName: 'Select All', bpgName: '' });

	  for (let i = 0; i < this.siteList.length; i++) {
	    if (i == 0) {
	      this.allSiteIds = this.siteList[i].siteId;
	    } else {
	      this.allSiteIds = this.allSiteIds + this.siteList[i].siteId + ",";
	    }
	  }
	  for (let i = 0; i < this.siteListSearch.length; i++) {
	    if (i == 0) {
	      this.allSiteIds = this.siteListSearch[i].siteId;
	    } else {
	      this.allSiteIds = this.allSiteIds + this.siteListSearch[i].siteId + ",";
	    }
	  }
	  this.getBpgList();
	  this.getBpgListSearch();


	});
      });

      this.getSiteName()
    }
    else if (this.loginUserAdminId === "1") {
      this.getSiteName()

      this.getSiteList();
      this.getBpgList();
      this.getBpgListSearch();
      this.getDocumentsFolderList();
      //this.getChapterGalleryList();
    }
    // this.getBpgList();
    // this.getBpgListSearch();

    this.landingDto = {
      "filter": {},
      "moduleId": 0,
      "page": 0,
      "presentRole": "string",
      "searchTerm": "",
      "size": 0,
      "sortDirection": "ASC",
      "sortProperty": "string",
      "uid": "string"
    }

    this.loginUserId = this.loginData.userId;
    // this.getChapterGalleryList();

    setTimeout(function () {
      this.spinner.hide();
    }.bind(this), 500);

  }
  /** get site name in the dropdown for lead admin
    * @class ConfigureGalleryComponent
    * @method getSiteName
    */
  getSiteName() {
    this.selectedSite = this.loginData.site.siteName;
    this.siteName = this.selectedSite;
    //this.selectedSiteSearch= this.loginData.site.siteName;
  }

  /** get site list in the dropdown
    * @class ConfigureGalleryComponent
    * @method getSiteList
    */
  getSiteList() {
    this.siteData = {
      "filter": {},
      "moduleId": 0,
      "page": 0,
      "presentRole": "string",
      "searchTerm": "string",
      "size": 0,
      "sortDirection": "ASC",
      "sortProperty": "string",
      "uid": "string"
    }

    this.bpgCommonService.getSiteList(this.siteData).subscribe(data => {
      this.siteList = data;
      this.siteListSearch = data;
      //filter default site from sitelist
      this.siteList = this.siteList.filter(site => site.locationCode !== 'DFLT');
      this.siteListSearch = this.siteListSearch.filter(site => site.locationCode !== 'DFLT');

      // this.siteList.unshift({ siteId: 0, siteName: 'Select Site', bpgName: '' });
      this.siteListSearch.unshift({ siteId: 0, siteName: 'Select All', bpgName: '' });


      if (this.siteList != null || this.siteListSearch != null) {
	for (var i = 0; i < this.siteList.length; i++) {
	  if (this.siteList[i].siteId == this.selectedSiteId) {
	    this.selectedSite = this.siteList[i].siteName;
	  }
	}

	for (var i = 0; i < this.siteListSearch.length; i++) {
	  if (this.siteListSearch[i].siteId == this.selectedSiteId) {
	    this.selectedSite = this.siteListSearch[i].siteName;
	  }
	}

	for (let i = 0; i < this.siteList.length; i++) {
	  if (i == 0) {
	    this.allSiteIds = this.siteList[i].siteId;
	  } else {
	    this.allSiteIds = this.allSiteIds + this.siteList[i].siteId + ",";
	  }
	}

	for (let i = 0; i < this.siteListSearch.length; i++) {
	  if (i == 0) {
	    this.allSiteIds = this.siteListSearch[i].siteId;
	  } else {
	    this.allSiteIds = this.allSiteIds + this.siteListSearch[i].siteId + ",";
	  }
	}

      }
    });
  }

  /** get gallery list
   * @class ConfigureGalleryComponent
   * @method getChapterGalleryList
   */
  public getDocumentsFolderList() {
    this.spinner.show();
    if (this.selectedSiteIdSearch == 0) {
      this.selectedSiteIdSearch = this.allSiteIds;
    }
    if (this.selectedBpgIdSearch == 0) {
      this.selectedBpgIdSearch = this.allBpgIds;
    }

    this.landingData = {
      "filter": { "siteId": this.selectedSiteIdSearch, "bpgId": this.selectedBpgIdSearch },
      "moduleId": 0,
      "page": this.page,
      "presentRole": "",
      "searchTerm": "",
      "size": this.limit,
      "sortDirection": "DESC",
      "sortProperty": "created_date_time",
      "uid": ""
    }
    console.log(JSON.stringify(this.landingData))
    this.userService.getDocumentsFolderList(this.landingData).subscribe(data => {
      this.documentsFolderList = data.content;
      console.log(JSON.stringify(this.documentsFolderList))

      this.numberOfElements = data.totalElements;
      this.spinner.hide();
      if (this.documentsFolderList.length == 0) {
	this.noDataFound = true;
	this.tableShow = false;

      } else {
	this.noDataFound = false;
	this.tableShow = true;
      }
    });
  }


  /** get bpg list in the dropdown
    * @class ConfigureGalleryComponent
    * @method getBpgList
    */
  getBpgList() {
    this.selectedBpgsData =
    {
      "filter": {
	"siteId": this.selectedSiteId,
	"adminId": this.loginUserAdminId,
	"userId": this.createdBy
      },
      "moduleId": 0,
      "page": 0,
      "presentRole": "string",
      "searchTerm": "string",
      "size": 0,
      "sortDirection": "ASC",
      "sortProperty": "string",
      "uid": "string"
    }
    this.bpgCommonService.getMyBPGsList(this.selectedBpgsData).subscribe(data => {
      this.bpgList = data;
      if (this.bpgList.length != 0) {
	//this.bpgList.unshift({bpgId: 0, bpgName: 'Select Site'});
      } else {
	this.bpgList.unshift({ bpgId: 0, bpgName: 'No Data found' });
      }



      if (this.bpgList != null) {

	for (var i = 0; i < this.bpgList.length; i++) {
	  // this.allBpgIds.push(this.bpgList[i].bpgId);
	  if (this.bpgList[i].bpgId == this.selectedBpgId) {
	    this.selectedBpg = this.bpgList[i].bpgName;
	  }
	}

	for (let i = 0; i < this.bpgList.length; i++) {
	  if (i == 0) {
	    this.allBpgIds = this.bpgList[i].bpgId;
	  } else {
	    this.allBpgIds = this.allBpgIds + this.bpgList[i].bpgId + ",";
	  }
	}
      }

    });
  }


  getBpgListSearch() {
    this.selectedBpgsData =
    {
      "filter": {
	"siteId": this.selectedSiteIdSearch,
	"adminId": this.loginUserAdminId,
	"userId": this.createdBy
      },
      "moduleId": 0,
      "page": 0,
      "presentRole": "",
      "searchTerm": "",
      "size": 0,
      "sortDirection": "ASC",
      "sortProperty": "",
      "uid": ""
    }
    this.bpgCommonService.getMyBPGsList(this.selectedBpgsData).subscribe(data => {
      this.bpgListSearch = data;

      if (this.bpgListSearch != null) {
	this.bpgListSearch.unshift({ bpgId: 0, bpgName: 'Select All' });

	for (var i = 0; i < this.bpgListSearch.length; i++) {
	  // this.allBpgIds.push(this.bpgList[i].bpgId);
	  if (this.bpgListSearch[i].bpgId == this.selectedBpgId) {
	    this.selectedBpg = this.bpgListSearch[i].bpgName;
	  }
	}


	for (let i = 0; i < this.bpgListSearch.length; i++) {
	  if (i == 0) {
	    this.allBpgIds = this.bpgListSearch[i].bpgId;
	  } else {
	    this.allBpgIds = this.allBpgIds + this.bpgListSearch[i].bpgId + ",";
	  }
	}
	if (this.loginUserAdminId === "2" || this.loginUserAdminId === "3" || this.isbpgAdmin || this.isbpgLeadAdmin) {

	  this.getDocumentsFolderList();
	}
      }


    });
  }

  /** get chapter id
  * @class ConfigureGalleryComponent
  * @method getChapterIds
  */
  getChapterIds() {
    this.landingData = {
      "filter": {
	"bpgId": this.selectedBpgId,
	"siteId": this.selectedSiteId
      },
      "moduleId": 0,
      "page": 0,
      "presentRole": "string",
      "searchTerm": "string",
      "size": 0,
      "sortDirection": "ASC",
      "sortProperty": "string",
      "uid": "string"
    }
    this.userService.getChapterByBpg(this.landingData).subscribe(data => {
      if (data != null) {
	for (var i = 0; i < data.length; i++) {
	  this.chapterId = data[i];
	}
      }
    });
  }


  /** For site change from site list
     * @class ConfigureGalleryComponent
     * @method siteChange
     * @returns Promise
     */
  siteChange(event) {
    this.selectedBpgId = null;
    this.selectedBpg = null;
    this.userFirstName = null;
    this.userId = null;
    this.selectedSiteId = event.siteId;
    this.bpgList = [];
    this.siteName = event.siteName;
    this.getBpgList();
    //this.getEventIdOnSelectOfSiteChapter();
    //this.eventId = null;

  }
  /** For bpg change from bpg list
    * @class ConfigureGalleryComponent
    * @method bpgChange
    * @returns Promise
    */

  bpgChange(event) {
    this.selectedBpgId = null;
    this.userFirstName = null;
    this.userId = null;
    this.selectedBpgId = event.bpgId;
    this.getChapterIds();
    //this.getUserList();
    //this.getEventIdOnSelectOfSiteChapter();
    //this.eventId = null;
  }

  /** checks if word exists in array
   * @class ConfigureGalleryComponent
   * @method isInArray
   */
  isInArray(array, word) {
    return array.indexOf(word.toLowerCase()) > -1;
  }


  /** For adding 365 days to current day
* @class ConfigureGalleryComponent
* @method addDays
* @params Date, number
*/
  addDays(date: Date, days: number): Date {
    date.setDate(date.getDate() + days);
    return date;
  }


  /** to submit resource
   * @class ConfigureGalleryComponent
   * @method onChapterGallerySubmit
   */
  public onManageFolderSubmit() {
    this.alertSuccess = false;
    this.alertFailure = false;
    this.alertUpdateSuccess = false;
    this.timeOutError = false;
    this.deleteSuccess = false;

    this.method = "addDocumentsFolder";
    this.param = '';
    if(this.editAndSave){
    this.msg1 = " Are you sure you want to update ? ";
  }else{
    this.msg1 = " Are you sure you want to save ? ";
  }

  }


  /** to add new admin
    * @class ConfigureGalleryComponent
    * @method addGallery
    */
  public addDocumentsFolder() {
    localStorage.setItem('siteId',this.selectedSiteId);
    localStorage.setItem('bpgId',this.selectedBpgId);
    localStorage.setItem("siteName",this.siteName);
    this.alertSuccess = false;
    this.alertFailure = false;
    this.timeOutError = false;
    this.deleteSuccess = false;
    this.alertUpdateSuccess = false;
    this.modifiedDateTime = new Date();
    let folderData = null;
    this.spinner.show();

    if (this.folderId != null) {
      folderData = {
	"folderId": this.folderId,
	"createdBy": this.createdBy,
	"createdDateTime": this.createdDateTime,
	"isActive": true,
	"modifiedBy": this.modifiedBy,
	"modifiedDateTime": this.modifiedDateTime,
	"bpgId": this.selectedBpgId,
	"siteId": this.selectedSiteId,
	"folderName": this.folderName,
	"chapterId": this.chapterId
      }
    } else {
      this.createdDateTime = new Date();
      folderData = {
	"createdBy": this.createdBy,
	"createdDateTime": this.createdDateTime,
	"isActive": true,
	"modifiedBy": this.modifiedBy,
	"modifiedDateTime": this.modifiedDateTime,
	//"fileName": this.selectedFileName,
	"bpgId": this.selectedBpgId,
	//"isEvent": this.eventPicture,
	"siteId": this.selectedSiteId,
	//"eventId": this.eventId,
	// "uploadedDate": this.datePipe.transform(new Date(), 'yyyy-MM-dd'),
	"folderName": this.folderName
      }
    }

    this.userService.addDocumentsFolder(folderData).subscribe(data => {
      if(data.body.message){
	this.spinner.hide();
	this.errorMsg = data.body.message;
	this.alertFailure = true;
	setTimeout(() => {
	  window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
	}, 200);
	return;
      }

      if(this.editAndSave){
	this.alertUpdateSuccess = true;
      }else{
      this.alertSuccess = true;
    }
      this.alertFailure = false;
      this.getDocumentsFolderList();
      this.spinner.hide();
      setTimeout(() => {
        this.resetGallery()
      }, 1500);
      setTimeout(() => {
	window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
      }, 200);
    }, err => {
      console.log(JSON.stringify(err.value.message));
      if (err.value.statusText == ConstantValues.unknownError) {
	this.alertFailure = true;
	this.alertSuccess = false;
      }
    })

  }


  /** For filtering data by current page
   * @class ConfigureGalleryComponent
   * @method pageChanged
   * @params event
   */
  pageChanged(event) {
    this.page = event - 1;
    this.currentPage = event;

    if ((this.currentPage * this.limit) < this.numberOfElements) {
      this.currentShowingElements = this.currentPage * this.limit;
    } else if ((this.currentPage * this.limit) >= this.numberOfElements) {
      this.currentShowingElements = this.numberOfElements;
    }
    this.getDocumentsFolderList();
  }

  /** Confirm on reset
    * @class ConfigureGalleryComponent
    * @method resetGallery
    */
  resetGallery() {
    setTimeout(() => {
      window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
    }, 200);
    this.folderId = null;
    this.folderName = null;
    this.editAndSave = false;
    // this.myInputVariable.nativeElement.value = "";
    this.selectedBpg = null;
    this.selectedBpgId = null;
    // this.selectedBpgIdSearch = 0;
    // this.selectedSiteIdSearch = 0;
    this.selectedBpgIdSearch = null;
    this.selectedSiteIdSearch = null;
    this.searchKey = null;
    this.LandingPaginationDTO.searchTerm = null;
    this.selectedFileName = "Upload < 500MB";
    this.selectedSiteId = localStorage.getItem('userSiteId');
    this.eventId = null;
    this.deleteSuccess = false;
    this.fileExtensionError = false;
    this.fileSizeExtensionError = false;
    this.alertSuccess = false;
    this.alertFailure = false;
    this.alertUpdateSuccess = false;
    this.timeOutError = false;
    this.selectedFile = null;
    this.isFileUploded = false;
    this.selectedBpgSearch = null;
    this.selectedSiteSearch = null;
    this.errorMsgUploadSave = false;
    this.documentName = "";
    this.filterType = null;
    this.selectedSite = this.loginData.site.siteName;
    this.eventPicture = true;
    this.firstEdit = false;

    if (this.loginUserAdminId === "3" || this.loginUserAdminId === "2" || this.isbpgAdmin || this.isbpgLeadAdmin) {
      this.selectedSiteIdSearch = 0;
      this.selectedBpgIdSearch = 0;
      this.getBpgListSearch();
    }
    this.getDocumentsFolderList();
    this.getBpgList();
  }

  public updateDocument(data,i){
    if(this.firstEdit == false){
      this.firstEdit = true;
      this.editFolder(data);
    }else{
    document.getElementById('edit'+i).setAttribute('data-toggle','modal');
    document.getElementById('edit'+i).setAttribute('data-target','#myModal');
    this.method = "editFolder";
    this.param = data;
    this.msg1 = " Your current changes will be discarded, do you want to continue ? ";
    }
  }


  /** For site change from site list
   * @class ConfigureGalleryComponent
   * @method siteChangeSearch
   * @returns Promise
   */
  siteChangeSearch(event) {

    this.selectedSiteIdSearch = event.siteId;
    //this.selectedBpgSearch = null;
    this.getBpgListSearch()
  }
  /** For bpg change from bpg list
    * @class ConfigureGalleryComponent
    * @method bpgChangeSearch
    * @returns Promise
    */

  bpgChangeSearch(event) {

    this.selectedBpgIdSearch = event.bpgId;

  }

  /** to Delete gallery
* @class ConfigureGalleryComponent
* @method deleteGallery
*/
  deleteDocumentsFolder(folderId) {
    this.alertSuccess = false;
    this.alertFailure = false;
    this.timeOutError = false;
    this.deleteSuccess = false;
    this.alertUpdateSuccess = false;
    this.spinner.show();
    this.userService.deleteDocumentsFolder(folderId).subscribe(data => {
      this.spinner.hide();
      window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
      this.deleteSuccess = true;
      this.alertSuccess = false;
      this.errorMsgUploadSave = false;
      console.log(JSON.stringify(this.documentsFolderList.length))
      console.log(JSON.stringify(this.numberOfElements))
      if (this.documentsFolderList.length == 1 && this.numberOfElements > 10) {
	this.currentPage = 0;
	this.page = 0;
	this.currentShowingElements = 10

      }

      this.getDocumentsFolderList();
    });
  }


  /** confirmation to delete gallery
* @class ConfigureGalleryComponent
* @method deleteGalleryConfirmation
*/
  public deleteFolderConfirmation(id) {
    this.alertSuccess = false;
    this.alertFailure = false;
    this.alertUpdateSuccess = false;
    this.timeOutError = false;
    this.deleteSuccess = false;

    this.method = "deleteDocumentsFolder";
    this.param = id;
    this.msg1 = "  Are you sure you want to delete ? ";
  }

  downloadDocument(urls, i) {
    var extension = urls.substring(urls.lastIndexOf('.') + 1);
    var link = document.getElementById('downloadFiles' + i);
    link.setAttribute('href', urls);
    link.setAttribute('download', urls);
    if (extension.includes('mp4')) {
      link.setAttribute('target', '_blank');
    }
  }


  /** to reset resource
   * @class ConfigureGalleryComponent
   * @method resetClick
   */
  resetClick() {
    this.method = "resetGallery";
    this.param = '';
    this.msg1 = " Your current changes will be discarded, do you want to continue ? ";
  }

  public getDocumentsFolderListForSearch() {
    this.page = 0;
    this.currentPage = 1;
    this.getDocumentsFolderList();

  }

  editFolder(data) {
    this.alertSuccess = false;
    this.alertFailure = false;
    this.alertUpdateSuccess = false;
    this.timeOutError = false;
    this.deleteSuccess = false;


    this.editAndSave = true;
    this.folderId = data.folderId;
    this.folderName = data.folderName;
    this.chapterId = data.chapterId;
    this.selectedBpgId = data.bpgId;
    this.selectedSiteId = data.siteId;
    this.siteName = data.siteName;
    this.bpgName = data.bpgName;
    this.selectedSite = this.siteName;
    this.selectedBpg = this.bpgName;
    this.createdDateTime = data.createdDateTime;
    window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
  }


  /** to select cancel
    * @class CreateAndEditExpenseClaimComponent
    * @method cancelClick
    */
  cancelClick() {
    this.method = "navigate";
    this.msg1 = " Are you sure you want to leave this page ? Changes you made may not be saved.";
    this.param = "";
  }

  navigate() {
    this.location.back();
    window.scrollTo(0, 0);
  }




}







